var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zM9 8H5C3.35 8 2 6.65 2 5s1.35-3 3-3h4V0H5C2.24 0 0 2.24 0 5s2.24 5 5 5h4V8zM6 4h8v2H6V4z",
    fill: "#687587"
  })));
}
export default SvgCopyLink;